/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorState } from './monitorState';
import { MonitorMinResponse } from './monitorMinResponse';
import { MonitorCreationItemDetailsOneOf } from './monitorCreationItemDetailsOneOf';


/**
 * @type MonitorCreationItemDetails
 * @export
 */
export type MonitorCreationItemDetails = MonitorCreationItemDetailsOneOf | MonitorMinResponse;

